/**
 * Shared frontend configuration — config shim for Phase 1/2/3 pages.
 *
 * Exports:
 *   API_URL        — backend base URL **including /api**, e.g. "http://localhost:8000/api"
 *                    Used as: fetch(`${API_URL}/payroll/runs`, ...)
 *   getAuthHeaders — returns a **plain** headers object suitable for native fetch().
 *                    Usage: fetch(url, { headers: getAuthHeaders() })
 *
 * @deprecated For new code prefer importing apiClient from lib/api.js directly —
 *             it injects auth headers automatically via axios interceptors.
 *
 * NOTE: lib/api.js exports BACKEND_URL (no /api) and a getAuthHeaders() that
 * wraps headers in { headers: {...} } for axios. This file intentionally uses
 * a different shape so that all fetch()-based pages work correctly without
 * introducing a dependency on axios.
 */

export const API_URL =
  `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

/**
 * Returns a flat headers object for native fetch().
 * Reads JWT token and multi-tenancy IDs from localStorage.
 */
export const getAuthHeaders = () => {
  const token     = localStorage.getItem('token');
  const companyId = localStorage.getItem('company_id');
  const userId    = localStorage.getItem('user_id');

  const headers = { 'Content-Type': 'application/json' };
  if (token)     headers['Authorization']  = `Bearer ${token}`;
  if (companyId) headers['X-Company-ID']   = companyId;
  if (userId)    headers['X-User-ID']      = userId;
  const branchId = localStorage.getItem('active_branch_id');
  if (branchId)  headers['X-Active-Branch-Id'] = branchId;

  return headers;
};
